import { useState } from 'react';

import myShopClient from '@services/nearlive';

/**
 * Fires the "email me the desktop link" action. Posts to the authed endpoint,
 * which stamps a Loops contact property; a Loops workflow sends the actual
 * email. The recipient is resolved server-side from the session, so we send no
 * body and never handle an email address client-side.
 */
export function useRequestDesktopLink() {
	const [status, setStatus] = useState('idle');

	const request = async () => {
		setStatus('sending');
		try {
			const client = await myShopClient();
			await client.post('/api/users/request-desktop-link');
			setStatus('sent');
			return true;
		} catch {
			setStatus('error');
			return false;
		}
	};

	return { request, status };
}
